<div class="row">
    <app-form-field label="Caméras disponibles">
        <app-select-filter-v2
                [parentFormGroup]="formGroup"
                parentFormControlName="deviceId"
                (_onSingleSelectionChange)="onCameraChange()"
                [elements]="videoDeviceElements">
        </app-select-filter-v2>
    </app-form-field>
</div>
<div class="row">
    <div class="col-12">
        <div class="button-bar justify-content-start">
            <app-button (clickEvent)="startRecording()" fill="solid" iconName="player-play-filled" [disabled]="!formGroup.valid || isRecording"></app-button>
            <app-button (clickEvent)="stopRecording()" fill="solid" iconName="player-stop-filled" [disabled]="!isRecording"></app-button>
            <p>{{ formattedElapsedTime }}</p>
        </div>
    </div>
    <app-form-field label="Aperçu en direct" size="12" [sizeLg]="12" [sizeXl]="12">
        <video #liveVideo autoplay muted></video>
    </app-form-field>
</div>